module.exports = __webpack_public_path__ + "img/m-1.8ed2055f.png";